import { useHandler } from "@redotech/react-util/hook";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { SettingsPermissions } from "@redotech/redo-model/permissions";
import { Payer } from "@redotech/redo-model/return-flow";
import { SubmitRepairState } from "@redotech/redo-return-ui/flows/return-flow/submit-repair";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { produce } from "immer";
import { memo, useContext } from "react";

export const SubmitRepairDetails = memo(function SubmitRepairDetails({
  state,
  setState,
}: StepTypeDetailsProps<SubmitRepairState>) {
  const team = useContext(TeamContext);
  const canEditReturnsSettings = useHasPermission(
    SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
  );

  const handleSafetyNet = useHandler((value: boolean) => {
    setState((state) =>
      produce(state, (state) => {
        state.option.labelPayer = value ? Payer.MERCHANT : Payer.CUSTOMER;
      }),
    );
  });

  const handleChargeFee = useHandler((value: boolean) => {
    setState((state) =>
      produce(state, (state) => {
        state.option.chargeFee = value;
      }),
    );
  });

  return (
    <>
      <RedoToggle
        description="Merchant pays for labels not covered by Redo."
        disabled={!canEditReturnsSettings}
        label="Safety net"
        setValue={handleSafetyNet}
        value={state.option.labelPayer === Payer.MERCHANT}
      />
      {team?.settings?.warranties?.repairFeeEnabled && (
        <RedoToggle
          description="Repair fees will be displayed to the customer."
          disabled={!canEditReturnsSettings}
          label="Display repair fee"
          setValue={handleChargeFee}
          value={state.option.chargeFee}
        />
      )}
    </>
  );
});
